import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3574019b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-campaign-subpage" }
const _hoisted_2 = { class: "filters p-d-flex" }
const _hoisted_3 = { class: "filter-campaign p-mr-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-status" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, {
    config: _ctx.config,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedCampaignID,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCampaignID) = $event)),
              options: _ctx.campaignFilterOptions,
              filter: true,
              showClear: true,
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Filter by campaign",
              emptyFilterMessage: "No campaign found"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_4
        ]),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _: 3
  }, 8, ["config", "loading"]))
}